module.exports = __webpack_public_path__ + "img/banner_wide_mobile_5G.70e48ea8.jpg";